import { State } from "store/state";

export const selectUser = (state: State): State["auth"] => state.auth;

/**
 * True while the current session was created by "view as another user" —
 * admin→exhibitor/organiser/supplier or organiser→exhibitor alike.
 *
 * Sourced from getMe(), so it survives a page refresh and a silent session
 * restore. The backend marks such a session with `returnToken` internally and
 * exposes these three fields together on the wire; any one of them present
 * means impersonation, so we check all three rather than trusting a single
 * field to always be populated (`impersonatedByEmail` depends on the issuer's
 * user record still being readable at issue time).
 *
 * Used to hide credential-management UI: an impersonating organiser must not
 * manage the exhibitor's 2FA. The API enforces the same rule independently
 * via `@DenyImpersonatedSession()` (403), so this selector is about not
 * showing a door that is already locked — never the only line of defence.
 */
export const selectIsImpersonating = (state: State): boolean =>
  Boolean(
    state.auth.impersonatedByEmail ||
      state.auth.impersonatedByRole ||
      state.auth.returnTokenExpiresAt
  );
